
import { IconButton, Tooltip, Typography } from "@mui/material"
import { cellGreenIfCstmClrTm, getterTime } from "branch/pages/ShippingProcess/columns"
import { shippingInvoiceColNm } from "branch/pages/ShippingProcess/constant"
import { BoxFR } from "components/BoxCustom"
import { jobOrderColNm } from "constants/jobOrderConstant"
import dayjs from "dayjs"
import { ArticleRounded, CheckCircleRounded, LocalAtmRounded, ReplyRounded } from "resource/muiImport"


export const shippingColumnsStart = ({ handleUpdateETA }) => [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: 'ShowDetailExpense',
    headerName: '365',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <LocalAtmRounded color="primary" />
        </IconButton>
      )
    }
  },
  // {
  //   field: 'ShowDetailExpenseChild',
  //   headerName: 'LIT',
  //   width: 40,
  //   align: 'center',
  //   renderCell: (params) => {
  //     return (
  //       <IconButton size="small" >
  //         <LocalAtmRounded color="primary" />
  //       </IconButton>
  //     )
  //   }
  // },
  {
    field: 'gotoJobOrder',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <Tooltip title="ไปที่หน้า 1.3" placement='top' followCursor>
          <IconButton size="small" onClick={() => {
            var win = window.open(window.location.origin + `/emily/DailyJob/ShpmId/${params.row.ShpmId}`, '_blank');
            win.focus();
          }}>
            <ReplyRounded color="primary" sx={{ transform: "scaleX(-1)" }} />
          </IconButton>
        </Tooltip>
      )
    }
  },
  {
    field: 'No',
    cellClassName: "normal-col",
    headerName: 'ลำดับ',
    width: 50,
    align: 'center',
  },
  {
    field: 'JobNo',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.JobNo,
    width: 150,
    editable: true,
  },
  {
    field: 'Bkg',
    cellClassName: "normal-col",
    headerName: 'Booking No.',
    width: 150,
    editable: true,
  },
  {
    field: 'IsOwnTuk',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.IsOwnTuk,
    width: 70,
    align: 'center',
    renderCell: (params) => params.value ? <CheckCircleRounded color="success" /> : null
  },
  {
    field: 'ManAccNNm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.ManAccNNm,
    width: 70,
  },
  {
    field: 'RecvDocDte',
    cellClassName: cellGreenIfCstmClrTm,
    headerName: shippingInvoiceColNm.RecvDocDte,
    type: 'dateTime',
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    width: 100,
  },
  {
    field: 'IP_InvNo',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.IP_InvNo,
    width: 120,
    editable: true,
  },
  {
    field: 'CusAbbr',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.CusAbbr,
    width: 80,
  },
  {
    field: 'Agnt',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.Agnt,
    width: 100,
    editable: true,
  },
  {
    field: 'Vssl',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.Vssl,
    width: 120,
    valueGetter: ({ value, row }) => `${value} V.${row.Voy}`
  },
  {
    field: 'Port',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.Port,
    width: 100,
    editable: true,
  },
  {
    field: 'CT',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.CT,
    width: 100,
    editable: true,
  },
  {
    field: 'KGM',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.KGM,
    width: 80,
    editable: true,
  },
  {
    field: 'M3',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.M3,
    width: 80,
    editable: true,
  },
  {
    field: 'Vol',
    cellClassName: "normal-col",
    headerName: "Vol",
    width: 70,
  },
  {
    field: 'Brnd',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.Brnd,
    width: 150,
    editable: true,
  },
  {
    field: 'ContNo',
    cellClassName: "normal-col",
    headerName: jobOrderColNm.ContNo,
    width: 150,
  },
  {
    field: 'ETD',
    headerName: 'ETD',
    width: 70,
    type: 'date',
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM") : "-",
    editable: true,
  },
  {
    field: 'ETA',
    headerName: 'ETA',
    width: 80,
    type: 'date',
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM") : "-",
    cellClassName: (params) => params.value ? params.row.IsCfETA ? "green-progress" : "yellow-progress" : "",
    renderCell: ({ id, value, row, field }) => {
      return value ?
        <BoxFR>
          <Typography variant="body2">{dayjs(value).format("DD/MM")}</Typography>
          <IconButton sx={{ p: 0 }} onClick={handleUpdateETA({ id, value, row, field })}>
            <CheckCircleRounded color={row.IsCfETA ? "success" : "disabled"} />
          </IconButton>
        </BoxFR> :
        "-"
    },
    editable: true,
  },
]